import CONSTANTS from './vars/CONSTANTS';

export default async function removeWishlist(handle) {
  const wishlist = localStorage.getItem(CONSTANTS.LOCAL_STORAGE_WISHLIST_KEY);
  const wishlistArray = wishlist ? wishlist.split(CONSTANTS.LOCAL_STORAGE_DELIMITER) : [];
  const productIndex = wishlistArray.indexOf(handle);

  if (productIndex !== -1) {
    wishlistArray.splice(productIndex, 1);
    const wishlistString = wishlistArray.join(CONSTANTS.LOCAL_STORAGE_DELIMITER);
    localStorage.setItem(CONSTANTS.LOCAL_STORAGE_WISHLIST_KEY, wishlistString);

    const event = new CustomEvent('wishlist:removed', {
      detail: {
        handle,
      },
    });
    document.dispatchEvent(event);
  }
}
